import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let StackedColumnsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-stacked-columns';
        }
    }
});
export const StackedColumnsPlugin = {
    name: 'e-stacked-columns',
    install(Vue) {
        Vue.component(StackedColumnsPlugin.name, StackedColumnsDirective);
    }
};
export let StackedColumnDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-stacked-column';
        }
    }
});
export const StackedColumnPlugin = {
    name: 'e-stacked-column',
    install(Vue) {
        Vue.component(StackedColumnPlugin.name, StackedColumnDirective);
    }
};
